<h1 mat-dialog-title>Create broadcast</h1>
<div mat-dialog-content>
  <mat-spinner *ngIf="!formData"></mat-spinner>
  <form [formGroup]="formData" (ngSubmit)="ok()" *ngIf="formData">
    <mat-tab-group (selectedIndexChange)="typeChange($event)">
      <mat-tab label="Scheduled game">
        <mat-form-field class="full-width">
          <mat-label>Licenced league</mat-label>
          <mat-select formControlName="league">
            <mat-optgroup *ngFor="let group of leagueGroups" [label]="group.federation">
              <mat-option *ngFor="let league of group.leagues" [value]="league">
                {{league.name}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="full-width" *ngIf="scheduleLoading || scheduledDays?.length">
          <mat-label>Scheduled game</mat-label>
          <mat-select formControlName="scheduledGame">
            <mat-spinner *ngIf="scheduleLoading" diameter="24"></mat-spinner>
            <mat-optgroup *ngFor="let day of scheduledDays" [label]="day.date.toDate().toDateString()">
              <mat-option *ngFor="let game of day.games" [value]="game">
                {{game.scheduled.toDate() | date : 'HH:mm'}} {{game.home.fullName}} - {{game.away.fullName}}
                (#{{game.gameNumber}}/{{game.gameId}})
                <span class="unresolved-tag" *ngIf="hasUnresolvedOpponent(game)">opponent not decided</span>
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>

        <p class="schedule-hint unresolved-hint" *ngIf="blockedByPlaceholder">
          This game still has a bracket placeholder for one side, so there is no
          team to build a broadcast from yet. The server re-reads the schedule
          every 5 minutes while a bracket opponent is undecided — pick it again
          once the opponent shows up.
        </p>

        <ng-container *ngIf="scheduleError && teams?.length">
          <p class="schedule-hint">
            Schedule could not be loaded — pick the teams manually below.
          </p>
          <mat-form-field class="full-width">
            <mat-label>Home team</mat-label>
            <mat-select formControlName="homeTeam">
              <mat-option *ngFor="let team of teams" [value]="team">{{team.fullName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>Away team</mat-label>
            <mat-select formControlName="awayTeam">
              <mat-option *ngFor="let team of teams" [value]="team">{{team.fullName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>Game id (optional — enables live stats)</mat-label>
            <input matInput formControlName="gameId" placeholder="e.g. 123456">
          </mat-form-field>
        </ng-container>

        <mat-checkbox formControlName="autopilot">Autopilot</mat-checkbox>
      </mat-tab>
      <mat-tab label="Published live game">
        <mat-form-field class="full-width">
          <mat-label>Published live game</mat-label>
          <mat-select formControlName="game">
            <mat-optgroup *ngFor="let day of publishedDays" [label]="day.date.toDate().toDateString()">
              <mat-option *ngFor="let game of day.games" [value]="game">
                {{game.scheduled.toDate() | date : 'HH:mm'}} {{game.home.fullName}} - {{game.away.fullName}}
                ({{game.gameId}})
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="Full manual game">
        <p>
          Game is not scored in My Ball Club system and will be operated via control UI.
        </p>
        <p>
          Adjust team names and colors in broadcast config.
        </p>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-flat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="ok()" [disabled]="blockedByPlaceholder">
    <mat-icon>add</mat-icon>
    Create broadcast
  </button>
</div>
